/**
 *
 * @notice ManutenzioniSlice to handle state of Manutenzioni globally.
 *
 * @dev This module contains the reducer configuration and its initialization.
 * @dev Is the sucker wich contains features of this slice.
 *
 */

// Redux.
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
// Axios.
import axios from "axios"
// gmapi.
import {
    API_KEY,
    listaMacchinariAPI,
    eliminaMacchinarioAPI,
    dettaglioMacchinariAPI,
    caricaFotoMacchinarioAPI,
    downloadFotoMacchinarioAPI,
    filesMacchinariAPI
} from "../../../common/gmApi"
// cookie.
import { tkbox, getCookie } from "../../../common/cookie"

/********************************************
 *                                          *
 * @notice AsyncThunk API(s) Implementation *
 *                                          *
 ********************************************/
/**
 *
 *  @dev Get Machinery data.
 *
 */
export const getManutenzioni = createAsyncThunk(
    // Action route.
    "manutenzioni/getManutenzioni",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                listaMacchinariAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.status === 200 && response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "getManutenzioni":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getManutenzioni":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getManutenzioni":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/**
 *
 *  @dev Upload Manutenzioni Image.
 *
 */
export const uploadManutenzioniImage = createAsyncThunk(
    // Action route.
    "manutenzioni/uploadManutenzioniImage",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { any } newLogo
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async ({ newLogo, id }, thunkAPI) => {
        try {
            var bodyFormData = new FormData()
            bodyFormData.append('allegato', newLogo, newLogo.name)

            const response = await axios.post(
                // url.
                caricaFotoMacchinarioAPI,
                // body.
                bodyFormData,
                // Queryparams.
                {
                    headers: { "Content-Type": "multipart/form-data" },
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_macchinari: id
                    },
                },
            )
            //
            //
            //
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response
                } else {
                    console.error('Error "uploadManutenzioniImage":', response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                console.error('Error "uploadManutenzioniImage":', response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "uploadManutenzioniImage":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/**
 *
 *  @dev Get Manutenzioni img by id.
 *
 */
export const getManutenzioniImgById = createAsyncThunk(
    // Action route.
    "manutenzioni/getManutenzioniImgById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { string } macchinarioId
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (macchinarioId, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                downloadFotoMacchinarioAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_macchinari: macchinarioId,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "getManutenzioniImgById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getManutenzioniImgById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getManutenzioniImgById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)


/**
 *
 *  @dev Get Files by id.
 *
 */
export const getFilesById = createAsyncThunk(
    // Action route.
    "manutenzioni/getFilesById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { string } macchinarioId
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (macchinarioId, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                filesMacchinariAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_macchinari: macchinarioId,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return response.data
                } else {
                    //console.error('Error "getFilesById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getFilesById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getFilesById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)



/**
 *
 *  @dev Get Machine info by id.
 *
 */
export const getMachineInfoById = createAsyncThunk(
    // Action route.
    "manutenzioni/getMachineInfoById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { string } idBoxMacchinari
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (idBoxMacchinari, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                listaMacchinariAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.status === 200 && response.data.gmapi.response.status === "ok") {
                    return {
                        data: response.data,
                        idBoxMacchinari: idBoxMacchinari
                    }
                } else {
                    //console.error('Error "getMachineInfoById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getMachineInfoById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getMachineInfoById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/**
 *
 *  @dev Get Machine docs by id.
 *
 */
export const getMachineDocsById = createAsyncThunk(
    // Action route.
    "manutenzioni/getMachineDocsById",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { string } idBoxMacchinari
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (idBoxMacchinari, thunkAPI) => {
        try {
            const response = await axios.get(
                // url.
                dettaglioMacchinariAPI,
                // body.
                // null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_macchinari: idBoxMacchinari
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.status === 200 && response.data.gmapi.response.status === "ok") {
                    return {
                        data: response.data,
                        idBoxMacchinari: idBoxMacchinari
                    }
                } else {
                    //console.error('Error "getMachineDocsById":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "getMachineDocsById":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "getMachineDocsById":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/**
 *
 *  @dev Delete machine item.
 *
 */
export const deleteMachine = createAsyncThunk(
    // Action route.
    "manutenzioni/deleteMachine",
    /**
     * 
     * @dev Async Function with axios http req.
     * 
     * @param { string } idBoxMacchinari
     * 
     * @param { AsyncThunkPayloadCreator } thunkAPI
     * @dev `thunkAPI` callback function that should return a promise
     * @dev handle with extraReducers to update the State.
     * @dev It takes two parameter too: first is the value of the dispatched action,
     * @dev and the second is the Thunk API config.
     * 
     * @returns AsyncThunk
     * 
     */
    async (idBoxMacchinari, thunkAPI) => {
        try {
            const response = await axios.delete(
                // url.
                eliminaMacchinarioAPI,
                // body.
                //null,
                // Queryparams.
                {
                    params: {
                        apikey: API_KEY,
                        tkbox: getCookie(tkbox),
                        id_box_macchinari: idBoxMacchinari,
                    },
                }
            )
            if (response.status === 200 && response.data.gmapi.auth === "ok") {
                if (response.data.gmapi.response.status === "ok") {
                    return {
                        data: response.data,
                        eventSender: idBoxMacchinari
                    }
                } else {
                    //console.error('Error "deleteMachine":',response.data.gmapi.response.error[0])
                    return thunkAPI.rejectWithValue(response.data.gmapi.response.error[0])
                }
            } else {
                //console.error('Error "deleteMachine":',response.data.gmapi.error)
                return thunkAPI.rejectWithValue(response.data.gmapi.error)
            }
        } catch (error) {
            console.error('Error "deleteMachine":', error.message)
            return thunkAPI.rejectWithValue(error.message)
        }
    }
)

/********************************************
 *                                          *
 * @notice createSlice implementation.      *
 *                                          *
 * @dev Create "manutenzioniSlice" feature. *
 * @dev UI views state controller.          *
 *                                          *
 ********************************************/
export const manutenzioniSlice = createSlice({
    // Name, used in action types.
    name: "manutenzioni",
    // The initial state for the reducer.
    initialState: {
        machineryItems: [],                // All machinery items.
        //needsReload: false,                // Does Component view needs reload (fire useEffects).
        defaultTabIndex: 0,                // Default tab index of "Tabs" child component.
        machineImg: "",               // Machine img.
        machineInfo: [],                   // Machine info.
        maintenanceContractsDocs: [],      // All maintenance contracts docs of a achine.
        interventionSheetDocs: [],         // All intervention sheet docs of a machine.
        maintenanceLedgerDocs: [],         // All maintenance ledger docs of a machine.
        userBookletAndMaintenanceDocs: [], // All userBooklet and maintenance docs of a machine.
        isFetching: false,                 // AsyncThunk is calling an API.
        isSuccess: false,                  // AsyncThunk is success from API call.
        isError: false,                    // AsyncThunk is fail from API call.
        errorMsg: "",                      // Error message container.
    },
    // Reducers, an object of "case reducers".
    // Key names will be used to generate actions.
    reducers: {
        /**
         * @dev Clean up the state.
         * @param {*} state 
         * @returns state
         */
        clearState: (state) => {
            state.isError = false
            state.isSuccess = false
            state.isFetching = false
            state.machineInfo = []
            state.maintenanceContractsDocs = []
            state.interventionSheetDocs = []
            state.maintenanceLedgerDocs = []
            state.userBookletAndMaintenanceDocs = []

            return state
        },
    },
    // AsyncThunk Reducers.
    // A "builder callback" function used to add more reducers, or
    // an additional object of "case reducers", where the keys should be other
    // action types.
    extraReducers: (builder) => {
        builder
            /*******************************************************************
             *
             * @dev getManutenzioni.
             *
             */
            .addCase(getManutenzioni.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true
                //state.needsReload = false // Component view doesn't needs refresh.

                // Update machineryItems sort by `data_ora_inserimento` key.
                const machineryItems = action.payload.gmapi.response.data
                state.machineryItems = machineryItems.sort((firstEl, secondEl) => (
                    firstEl["data_ora_inserimento"] < secondEl["data_ora_inserimento"] ? 1 : -1
                ))
            })
            .addCase(getManutenzioni.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getManutenzioni, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             *
             * @dev getMachineInfoById.
             *
             */
            .addCase(getMachineInfoById.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true

                const id_box_macchinari = action.payload.idBoxMacchinari
                const machineryItems = action.payload.data.gmapi.response.data

                state.machineInfo = machineryItems.find(obj => obj.id_box_macchinari === id_box_macchinari)

                state.defaultTabIndex = 0 // Tab: "Informazioni".
            })
            .addCase(getMachineInfoById.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getMachineInfoById.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             *
             * @dev uploadManutenzioniImage.
             *
             */
            .addCase(uploadManutenzioniImage.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true
                state.machineImg = action.payload.data.gmapi.response.data
            })
            .addCase(uploadManutenzioniImage.pending, (state) => {
                state.isFetching = true
            })
            .addCase(uploadManutenzioniImage.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             *
             * @dev getManutenzioniImgById.
             *
             */
            .addCase(getManutenzioniImgById.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true
                state.machineImg = action.payload.gmapi.response.data

                // Handle empty image data.
                /*
                switch (action.payload.gmapi.response.data) {
                    case "data:directory;base64,":
                        state.employeeImg = "data:image/png;base64,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"
                        break
                    default:
                        state.employeeImg = action.payload.gmapi.response.data
                        break
                }
                */
            })
            .addCase(getManutenzioniImgById.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getManutenzioniImgById.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             *
             * @dev getFilesById.
             *
             */
            .addCase(getFilesById.fulfilled, (state, action) => {
                state.isFetching = false
                state.isSuccess = true
                state.files = action.payload.gmapi.response.data
            })
            .addCase(getFilesById.pending, (state) => {
                state.isFetching = true
            })
            .addCase(getFilesById.rejected, (state, action) => {
                state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
            })
            /*******************************************************************
             *
             * @dev getMachineDocsById.
             *
             */
            .addCase(getMachineDocsById.fulfilled, (state, action) => {
                const idBoxMacchinari = action.payload.idBoxMacchinari

                //state.maintenanceContractsDocs = action.payload.data.gmapi.response.data
                const machineries = action.payload.data.gmapi.response.data

                let maintenanceContractsDocs = []
                let interventionSheetDocs = []
                let maintenanceLedgerDocs = []
                let userBookletAndMaintenanceDocs = []

                for (let index = 0; index < machineries.length; index++) {
                    const machine = machineries[index];

                    if (machine.id_box_macchinari === idBoxMacchinari) {
                        switch (machine.tipo) {
                            case "CNTR":
                            case "Contratti Manutenzioni":
                                maintenanceContractsDocs.push(machine)
                                break;
                            case "SCDI":
                            case "Scheda di intervento":
                                interventionSheetDocs.push(machine)
                                break;
                            case "RGMN":
                            case "Registro Manutenzioni":
                                maintenanceLedgerDocs.push(machine)
                                break;
                            case "LBUM":
                            case "Libretto Uso e Manutenzioni":
                                userBookletAndMaintenanceDocs.push(machine)
                                break;
                            default:
                                break;
                        }
                    }
                }

                if (maintenanceContractsDocs.length > 0) {
                    state.maintenanceContractsDocs = maintenanceContractsDocs
                }
                if (interventionSheetDocs.length > 0) {
                    state.interventionSheetDocs = interventionSheetDocs
                }
                if (maintenanceLedgerDocs.length > 0) {
                    state.maintenanceLedgerDocs = maintenanceLedgerDocs
                }
                if (userBookletAndMaintenanceDocs.length > 0) {
                    state.userBookletAndMaintenanceDocs = userBookletAndMaintenanceDocs
                }


            })
            .addCase(getMachineDocsById.pending, (state) => {
            })
            .addCase(getMachineDocsById.rejected, (state, action) => {
            })
            /*******************************************************************
             *
             * @dev deleteMachine.
             *
             */
            .addCase(deleteMachine.fulfilled, (state, action) => {
                //state.isFetching = false
                //state.isSuccess = true
                //state.needsReload = true  // Component view needs refresh.

                // Get the eventSender from the action payload.
                const idBoxMacchinari = action.payload.eventSender
                // Find the object wich corresponding id.
                const machineryToRemove = state.machineryItems.findIndex((obj) => obj.id_box_macchinari === idBoxMacchinari)

                // If found then remove it from the list.
                if (machineryToRemove > -1) {
                    state.machineryItems.splice(machineryToRemove, 1) // Remove the item selected.
                }
            })
            .addCase(deleteMachine.pending, (state) => {
                //state.isFetching = true
            })
            .addCase(deleteMachine.rejected, (state, action) => {
                //state.isFetching = false
                state.isError = true
                state.errorMsg = action.payload
                //state.needsReload = true  // Component view needs refresh.
            })
    },
})

// Export the reducer.
export const {
    clearState,
    cleanUpMachineInfo,
} = manutenzioniSlice.actions

// Export the Slice by name.
export const manutenzioniSelector = (state) => state.manutenzioni
